import { render, staticRenderFns } from "./ageMix.vue?vue&type=template&id=2cd61beb"
import script from "./ageMix.vue?vue&type=script&lang=js"
export * from "./ageMix.vue?vue&type=script&lang=js"
import style0 from "./ageMix.vue?vue&type=style&index=0&id=2cd61beb&prod&lang=scss&scope=true"
import style1 from "./ageMix.vue?vue&type=style&index=1&id=2cd61beb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports